module.exports = __webpack_public_path__ + "static/img/full01.9261f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/full01.png
// module id = GWd3
// module chunks = 0